export default __webpack_public_path__ + "static/media/EM0310.34I-44544_-26439_0.b68012c8.jpg";